import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./Courses.css";
import { Alert, Button, Container, Table, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import BaseUrl from "../../base-api";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { submitPaymentForm } from "../../Utils/Commons";
import logo from "./../../assets/logo.jpg";
import hkcl from "../../assets/hkcl.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import imageCompression from "browser-image-compression";
import moment from "moment";
const Courses = () => {
  const navigate = useNavigate();
  const [date, setDate] = useState(null);
  const [courses, setCourses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [payment, setPayment] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [photo, setPhoto] = useState(null);
  const [sign, setSign] = useState(null);
  const [apiError, setApiError] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);
  const [historyData, setHistoryData] = useState(null);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [retryLoading, setRetryLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [upgradePaymentStatus, setUpgradePaymentStatus] = useState(null);
  const [cancelModal, setCancelModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [cancelReason, setCancelReason] = useState("");
  const [keepCombination, setKeepCombination] = useState(false);
  useEffect(() => {
    // Fetch enrolled courses which includes upgrade payment status
    axios
      .get(`${BaseUrl}/app/fetchEnrolledCourses`, {
        headers: {
          Authorization: localStorage.getItem("$3ingT0k3n"),
        },
      })
      .then(function (response) {
        setCourses(response.data);
        setApiError(false);
        
        // Extract upgrade payment status from the first course's data
        if (response.data && response.data.length > 0) {
          const firstCourse = response.data[0];
          if (firstCourse.upgradePaymentStatus) {
            setUpgradePaymentStatus(firstCourse.upgradePaymentStatus);
          }
        }
        
        response.data[0].documentsDto.map(async (data, index) => {
              if (data.data) {
                const base64Image = "data:image/jpeg;base64," + data.data;
                const compressedImageBase64 = await compressImage(base64Image);
                switch (data.abbr) {
                  case "photo":
                    setPhoto(compressedImageBase64);
                    break;
                  case "sign":
                    setSign(compressedImageBase64);
                    break;
                  default:
                    break;
                }
              }
            });
            const datetimeStamp = response.data[0].enrolledOn;
            const dateOnly = extractDate(datetimeStamp);
            setDate(dateOnly);
          })
          .catch(function (error) {
            setApiError(true);
          });
  }, []);
  const payRegFee = async () => {
    try {
      const response = await axios.post(
        `${BaseUrl}/payRegFee`,
        {},
        {
          headers: {
            Authorization: localStorage.getItem("$3ingT0k3n"),
          },
        }
      );
      if (response.status == 200) {
        toast.success(response.data.message, {
          className: "toast-large",
          position: "top-center",
        });
        setLoadingMessage("Waiting for payment confirmation....");
        setPayment(true);
        submitPaymentForm(response.data);
      } else toast.error(response.data.message, { position: "top-center" });
    } catch (error) {
      toast.error(error.response.data.message, { position: "top-center" });
    }
  };
  const payCourseFee = async () => {
    try {
      const response = await axios.post(
        `${BaseUrl}/payCourseFee`,
        {},
        {
          headers: {
            Authorization: localStorage.getItem("$3ingT0k3n"),
          },
        }
      );
      if (response.status == 200) {
        toast.success(response.data.message, {
          className: "toast-large",
          position: "top-center",
        });
        setLoadingMessage("Waiting for payment confirmation....");
        setPayment(true);
        submitPaymentForm(response.data);
      } else toast.error(response.data.message, { position: "top-center" });
    } catch (error) {
      toast.error(error.response.data.message, { position: "top-center" });
    }
  };

  const compressImage = async (base64Image) => {
    const response = await fetch(base64Image);
    const blob = await response.blob();
    const options = {
      maxSizeMB: 2,
      maxWidthOrHeight: 1200,
      useWebWorker: true,
    };
    try {
      const compressedBlob = await imageCompression(blob, options);
      const compressedBase64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(compressedBlob);
        reader.onloadend = () => resolve(reader.result);
      });

      return compressedBase64;
    } catch (error) {
      console.error("Error during image compression", error);
      return base64Image;
    }
  };

  const downloadDetails = async (course) => {
    try {
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const currentTime = new Date().toLocaleString();

      const websiteName =
        "Guru Jambheshwar University of Science & Technology, Hisar";
      const websiteNameWork = "Admission Form";
      const websitelogName = "and";
      const websiteHkcl = "Haryana Knowledge Corporation Limited (HKCL)";
      // const websiteNameWork = "Registration Form";

      const imageWidth = 20;
      const imageHeight = 20;
      const imageX = 10;

      doc.setFont("helvetica");

      const addHeader = () => {
        doc.setFontSize(8).setTextColor("black");
        const generatedTextWidth = doc.getTextWidth(
          `Generated on: ${currentTime}`
        );
        const generatedX = pageWidth - generatedTextWidth - 10;
        doc.text(`Generated on: ${currentTime}`, generatedX, 10);
        doc.text("https://gjuskillcourses.hkcl.in", 10, 10);
      };

      doc.setFontSize(16).setFont("helvetica", "bold");
      addHeader();
      doc.addImage(logo, "JPEG", imageX, 12, imageWidth, imageHeight);

      doc.setFontSize(12).setTextColor("green");

      doc.text(websiteName, imageX + imageWidth + 12, 20);
      doc.text(websitelogName, imageX + imageWidth + 70, 25);
      doc.text(websiteHkcl, imageX + imageWidth + 30, 30);

      const websiteNameWorkWidth = doc.getTextWidth(websiteNameWork);
      const centerX = (pageWidth - websiteNameWorkWidth) / 2;
      const textY = 37;

      doc.text(websiteNameWork, centerX - 4, textY);

      const textHeight = 1.5;
      doc.line(
        centerX - 4,
        textY + textHeight,
        centerX - 3 + websiteNameWorkWidth,
        textY + textHeight
      );
      doc.addImage(
        hkcl,
        "JPEG",
        pageWidth - imageX - imageWidth - 5,
        14,
        imageWidth + 5,
        imageHeight
      );

      doc.setFontSize(12).setTextColor("green");
      doc.text("Personal Details", 15, 40);
      doc.autoTable({
        startY: 44,
        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 100 },
        },
        body: [
          [
            { content: "Candidate Name", styles: { fontStyle: "bold" } },
            course.candidateName,
          ],
          [
            { content: "Father Name", styles: { fontStyle: "bold" } },
            course.fatherName,
          ],
          [
            { content: "Mobile Number", styles: { fontStyle: "bold" } },
            course.mobileNumber,
          ],
          [{ content: "Email", styles: { fontStyle: "bold" } }, course.email],
          [
            { content: "Date of Birth", styles: { fontStyle: "bold" } },
            moment(course.dob).format("DD/MM/YYYY"),
          ],
          [
            { content: "Full Address", styles: { fontStyle: "bold" } },
            `${course.address}, ${course.district}, ${course.state}, ${course.country}, ${course.pincode}`,
          ],
        ],
        theme: "grid",
        styles: {
          lineWidth: 0.1,
          lineColor: [0, 0, 0],
          fontSize: 8,
        },
        didDrawPage: (data) => {
          if (data.pageNumber > 1) {
            addHeader();
          }

          const x = 160;
          const y = 44;
          doc.addImage(photo, "JPEG", x, y, 35, 35);
        },
      });

      // Prepare bulleted course text
      let enrolledCourseText;
      if (course.otherCourses && course.otherCourses.length === 1) {
        enrolledCourseText = course.otherCourses[0];
      } else {
        enrolledCourseText = course.parentCourse;
        if (course.otherCourses && course.otherCourses.length > 0) {
          enrolledCourseText += ":\n" + course.otherCourses.map(c => `- ${c}`).join("\n");
        }
      }

      doc.setFontSize(12).setTextColor("green");
      doc.text("Course Details", 15, doc.autoTable.previous.finalY + 10);
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 12,
        body: [
          [
            { content: "Enrolled Course", styles: { fontStyle: "bold" } },
            enrolledCourseText,
          ],
        ],
        theme: "grid",
        styles: {
          lineWidth: 0.1,
          lineColor: [0, 0, 0],
          cellPadding: 3,
          fontSize: 10,
        },
        didDrawPage: (data) => {
          if (data.pageNumber > 1) {
            addHeader();
          }
        },
        // Wrap text inside the cell
        columnStyles: {
          1: { cellWidth: 130 }, // adjust width to wrap bullet list
        },
      });

      doc.setFontSize(12).setTextColor("green");
      doc.text(
        "Details of 12th Standard or Equivalent",
        15,
        doc.autoTable.previous.finalY + 10
      );
      doc.setFontSize(16);
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 15,
        body: [
          [
            { content: "Roll Number", styles: { fontStyle: "bold" } },
            course.rollNumber,
          ],
          [{ content: "Board", styles: { fontStyle: "bold" } }, course.board],
          [
            { content: "Passing Month-Year", styles: { fontStyle: "bold" } },
            course.schoolMonth + "-" + course.schoolYear,
          ],
          [
            { content: "Marks Obtained", styles: { fontStyle: "bold" } },
            course.marksObtained + " out of " + course.totalMarks,
          ],
        ],
        theme: "grid",
        styles: {
          lineWidth: 0.1,
          lineColor: [0, 0, 0],
          fontSize: 8,
        },
        didDrawPage: (data) => {
          if (data.pageNumber > 1) {
            addHeader();
          }
        },
      });

      doc.setFontSize(12).setTextColor("green");
      doc.text("Submitted Documents", 15, doc.autoTable.previous.finalY + 10);
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 15,
        head: [["Sr. No.", "Name"]],
        body: course.documentsDto.map((item, index) => [
          index + 1,
          item.docName,
        ]),
        theme: "grid",
        styles: {
          lineWidth: 0.1,
          lineColor: [0, 0, 0],
          halign: "center",
          fontSize: 10,
        },
        columnStyles: {
          0: { cellWidth: 40 },
        },
        didDrawPage: (data) => {
          // Add header on new pages
          if (data.pageNumber > 1) {
            addHeader();
          }
        },
      });
      const paragraphText =
        "I declare that the information provided by me in the application form is true and correct to the best of my knowledge, and I have not concealed any facts. I also confirm that I have carefully read all the guidelines and instructions provided on the admission portal before submitting my application. I also acknowledge the importance of providing correct contact details, as all course-related updates will be sent to my registered mobile number and email ID. I am fully aware that the course once selected cannot be changed under any circumstances and that the course fee, once paid, is non-refundable and non-transferable. I also give my consent to receive updates and course-related information on my registered mobile number/WhatsApp and email ID.";

      const textStartY = doc.autoTable.previous.finalY + 10;
      const signatureStartY = textStartY + 25;

      doc.setFontSize(8);

      const lines = doc.splitTextToSize(paragraphText, 175);

      doc.text(lines, 15, textStartY, { maxWidth: 180, align: "justify" });

      doc
        .setFontSize(8)
        .setFont("helvetica", "underline")
        .setTextColor("black");

      const marginBottom = 10;
      const signatureTextHeight = 10;
      const signatureImageHeight = 10;

      const signatureTextY = doc.internal.pageSize.height - marginBottom;
      const signatureImageY = signatureTextY - signatureImageHeight - 5;

      doc.addImage(
        sign,
        "JPEG",
        pageWidth - 50,
        signatureImageY,
        35,
        signatureImageHeight
      );

      doc.text("(Applicant Signature)", pageWidth - 40, signatureTextY);

      doc.save("Admission Form.pdf");
    } catch (error) {
      console.error("Failed to generate PDF:", error);
      alert("Failed to generate PDF. Please try again.");
    }
  };

  // Group upgrade history by parent course, previous course, and date
  const groupHistoryByParentCourse = (historyData) => {
    const grouped = {};
    
    // Sort history data by timestamp (newest first)
    const sortedData = [...historyData].sort((a, b) => 
      new Date(b.upgradeDate) - new Date(a.upgradeDate)
    );
    
    // Find the latest upgrade timestamp and its previous course name
    const latestTimestamp = sortedData[0]?.upgradeDate;
    const latestPreviousCourseName = sortedData[0]?.previousCourseName;
    
    sortedData.forEach(record => {
      // Normalize date to just the date part (remove time component)
      const normalizedDate = new Date(record.upgradeDate).toDateString();
      const key = `${record.parentCourseName}-${record.previousCourseName}-${normalizedDate}`;
      
      // Determine if this is the latest upgrade
      const isLatestUpgrade = record.upgradeDate === latestTimestamp;
      
      if (!grouped[key]) {
        grouped[key] = {
          parentCourseName: record.parentCourseName,
          previousCourseName: record.previousCourseName,
          upgradeDate: record.upgradeDate,
          courseNames: [],
          active: record.active,
          paymentReference: record.paymentReference,
          mappingType: record.mappingType,
          isLatestUpgrade: isLatestUpgrade,
          latestPreviousCourseName: latestPreviousCourseName
        };
      }
      grouped[key].courseNames.push(record.courseName);
    });
    
    return Object.values(grouped);
  };

  const handleUpgradeHistory = () => {
    setHistoryLoading(true);
    axios
      .get(`${BaseUrl}/app/upgradeHistory`, {
        headers: {
          Authorization: localStorage.getItem("$3ingT0k3n"),
        },
      })
      .then((res) => {
        setHistoryData(res.data);
        setHistoryModal(true);
        setHistoryLoading(false);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Failed to load upgrade history. Please try again.", {
          position: "top-center",
        });
        setHistoryLoading(false);
      });
  };

  const handleRetryPayment = (record) => {
    setRetryLoading(true);
    axios
      .post(`${BaseUrl}/app/retryUpgradePayment`, {
        headers: {
          Authorization: localStorage.getItem("$3ingT0k3n"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.paymentUrl) {
          toast.success("Redirecting to payment gateway...", { position: "top-center" });
          submitPaymentForm(res.data);
        } else {
          toast.success(res.data.message || "Payment retry initiated successfully.", { position: "top-center" });
          setRetryLoading(false);
          // Refresh data by calling APIs again
          setTimeout(() => {
            // Fetch enrolled courses
            axios
              .get(`${BaseUrl}/app/fetchEnrolledCourses`, {
                headers: {
                  Authorization: localStorage.getItem("$3ingT0k3n"),
                },
              })
              .then((response) => {
                setCourses(response.data);
                
                // Extract upgrade payment status from the first course's data
                if (response.data && response.data.length > 0) {
                  const firstCourse = response.data[0];
                  if (firstCourse.upgradePaymentStatus) {
                    setUpgradePaymentStatus(firstCourse.upgradePaymentStatus);
                  }
                }
                
                const datetimeStamp = response.data[0]?.enrolledOn;
                if (datetimeStamp) {
                  const dateOnly = extractDate(datetimeStamp);
                  setDate(dateOnly);
                }
              })
              .catch(function (error) {
                setApiError(true);
              });
          }, 15000);
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Failed to retry payment. Please try again.", {
          position: "top-center",
        });
        setRetryLoading(false);
      });
  };

  const handleCancelUpgrade = (record) => {
    setSelectedRecord(record);
    setCancelModal(true);
  };

  const openCancelModal = (record) => {
    setSelectedRecord(record);
    setCancelReason("");
    setKeepCombination(false);
    setCancelModal(true);
  };

  const confirmCancelUpgrade = () => {
    if (!selectedRecord || !cancelReason.trim()) {
      toast.error("Please provide a reason for cancellation.", { position: "top-center" });
      return;
    }

    setCancelLoading(true);
    axios
      .post(`${BaseUrl}/app/cancelUpgrade`, {
        reason: cancelReason.trim(),
        keepUpgradeCombination: keepCombination
      }, {
        headers: {
          Authorization: localStorage.getItem("$3ingT0k3n"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        toast.success(res.data.message || "Upgrade cancelled successfully.", { position: "top-center" });
        setCancelModal(false);
        setSelectedRecord(null);
        setCancelReason("");
        setKeepCombination(false);
        setCancelLoading(false);
        // Refresh page to call APIs again
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Failed to cancel upgrade. Please try again.", {
          position: "top-center",
        });
        setCancelLoading(false);
      });
  };

  const handleRetryUpgradePayment = () => {
    if (!upgradePaymentStatus) return;
    
    setRetryLoading(true);
    axios
      .post(`${BaseUrl}/app/retryUpgradePayment`, {
        parentCourse: upgradePaymentStatus.parentCourse,
        selectedCourses: upgradePaymentStatus.selectedCourses,
        upgradeRequestTime: upgradePaymentStatus.upgradeRequestTime
      }, {
        headers: {
          Authorization: localStorage.getItem("$3ingT0k3n"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.paymentUrl) {
          toast.success("Redirecting to payment gateway...", { position: "top-center" });
          submitPaymentForm(res.data);
        } else {
          toast.success(res.data.message || "Payment retry initiated successfully.", { position: "top-center" });
          setRetryLoading(false);
          // Refresh page to call APIs again
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Failed to retry payment. Please try again.", {
          position: "top-center",
        });
        setRetryLoading(false);
      });
  };

  function extractDate(datetimeStamp) {
    const date = new Date(datetimeStamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  return (
    <div>
      <Container
        className="py-3 border round mt-3"
        style={{
          width: "97%",
          backgroundColor: "#f6f5f591",
          boxShadow:
            "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          borderRadius: "9px",
        }}
      >
        {/* Upgrade Payment Status Banner */}
        {upgradePaymentStatus && upgradePaymentStatus.hasPendingUpgrade && (
          <Alert color="warning" className="mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="mb-1">
                  <FontAwesomeIcon icon={faExclamationCircle} className="mr-2" />
                  Pending Upgrade Payment
                </h6>
                <p className="mb-0">{upgradePaymentStatus.message || "No message available"}</p>
                <small className="text-muted">
                  <strong>Course:</strong> {upgradePaymentStatus.parentCourse || "N/A"}<br />
                  <strong>Selected:</strong> {upgradePaymentStatus.selectedCourses ? upgradePaymentStatus.selectedCourses.join(", ") : "N/A"}<br />
                  <strong>Status:</strong> {upgradePaymentStatus.paymentStatus || "N/A"}<br />
                  <strong>Can Retry:</strong> {upgradePaymentStatus.canRetry ? "Yes" : "No"}<br />
                  <strong>Has Pending:</strong> {upgradePaymentStatus.hasPendingUpgrade ? "Yes" : "No"}
                </small>
              </div>
              <div>
                {upgradePaymentStatus.canRetry && (
                  <button
                    className="btn btn-warning btn-sm mr-2"
                    onClick={handleRetryUpgradePayment}
                    disabled={retryLoading}
                  >
                    {retryLoading ? "Retrying..." : "Retry Payment"}
                  </button>
                )}
                {upgradePaymentStatus.canCancel && (
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => openCancelModal({
                      previousCourseName: upgradePaymentStatus.parentCourse,
                      upgradedCourseName: upgradePaymentStatus.selectedCourses ? upgradePaymentStatus.selectedCourses.join(", ") : "N/A",
                      upgradeDate: upgradePaymentStatus.upgradeRequestTime,
                      active: false,
                      paymentReference: null
                    })}
                    disabled={cancelLoading}
                  >
                    Cancel Upgrade
                  </button>
                )}
              </div>
            </div>
          </Alert>
        )}
        <div style={{ textAlign: "justify", fontSize: "0.9rem" }}>
          <h4 className="text-center" style={{ color: "#123fae" }}>
            GENERAL INSTRUCTIONS
          </h4>
          <ol>
            <li>
              {" "}
              Dear Candidate, once you have enrolled in a course, it will appear
              in the table below.
            </li>
            <li>
              {" "}
              Pay the registration fee of ₹101 by clicking the 'Pay Registration
              Fee' button.
            </li>
            <li>
              {" "}
              After successfully paying the registration fee, please wait for
              3-4 working days for the university to approve your uploaded
              documents.
            </li>
            <li>
              {" "}
              Once your documents are approved, proceed to pay the full course
              fee.
            </li>
            <li>
              {" "}
              If your uploaded documents are rejected, please re-upload the
              required documents for review.
            </li>
            <li>
              {" "}
              You can only edit your admission form till the payment of Registration fee.
            </li>
          </ol>
        </div>
        <hr></hr>
        <div className="text-center">
          <h1
            style={{
              backgroundColor: "#4545ee9e",
              color: "white",
              borderRadius: "3px",
            }}
          >
            {" "}
            Enrolled Courses
          </h1>
          <div className="table-responsive">
            <Table striped className="mt-3">
              <thead>
                <tr className="table-warning">
                  <th> Course Name </th>
                  <th> Enrolled Date </th>
                  <th> Approval Status </th>
                  <th>Remarks </th>
                  <th> Fee Status </th>
                  {courses.some((c) => c.feeStatus) && <th> Actions </th>}
                </tr>
              </thead>

              <tbody>
                {courses.map((c) => (
                  <tr>
                    <td> {c.course} </td>
                    <td> {date} </td>
                    <td>
                      {c.applicationStatus === "REGISTERED" ? (
                        <Button
                          className="btn-sm btn-success"
                          onClick={payRegFee}
                        >
                          Pay Registration Fee
                        </Button>
                      ) : (
                        <FontAwesomeIcon
                          icon={
                            c.applicationStatus == "Approved"
                              ? faCheckCircle
                              : faExclamationCircle
                          }
                          style={{
                            color:
                              c.applicationStatus == "Approved"
                                ? "green"
                                : "red",
                          }}
                        ></FontAwesomeIcon>
                      )}
                    </td>

                    <td> {c.remarks} </td>

                    <td>
                      {c.applicationStatus === "Approved" && !c.feeStatus ? (
                        <button
                          className="btn-sm btn-primary"
                          onClick={payCourseFee}
                        >
                          Pay Fee
                        </button>
                      ) : (
                        <FontAwesomeIcon
                          icon={
                            c.feeStatus ? faCheckCircle : faExclamationCircle
                          }
                          style={{ color: c.feeStatus ? "green" : "red" }}
                        ></FontAwesomeIcon>
                      )}
                    </td>
                    {c.feeStatus && (
                      <td>
                        <a
                          style={{ color: "blue" }}
                          href=""
                          onClick={(e) => {
                            e.preventDefault();
                            downloadDetails(c);
                          }}
                        >
                          Print
                        </a>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {courses.length > 0 && !apiError && (
            <div className="text-center mt-3">
              {/* Upgrade Course Button - separate logic */}
              {courses.some(c => c.applicationStatus === "Approved" && c.course !== "HS-CIT (A+)" && c.feeStatus === true) && (
                <button 
                  className="btn btn-success mr-2"
                  onClick={() => navigate('/SideBar/upgrade-course')}
                >
                  Upgrade Course
                </button>
              )}
              
              {/* Upgrade History Button - separate logic */}
              {courses.some(c => c.hasUpgraded === true) && (
                <button 
                  className="btn btn-info ml-2"
                  onClick={handleUpgradeHistory}
                  disabled={historyLoading}
                >
                  {historyLoading ? "Loading..." : "Upgrade History"}
                </button>
              )}
            </div>
          )}
        </div>

        {/* Upgrade History Modal */}
        <Modal isOpen={historyModal} toggle={() => setHistoryModal(!historyModal)} size="lg">
          <ModalHeader toggle={() => setHistoryModal(!historyModal)}>Upgrade History</ModalHeader>
          <ModalBody>
            {historyData && (
              <div>
                {historyData.length > 0 ? (
                  <div>
                    {groupHistoryByParentCourse(historyData).map((group, index) => (
                      <div key={index} className="mb-4 p-3 border rounded">
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <p><strong>Date:</strong> {new Date(group.upgradeDate).toLocaleDateString()}</p>
                          </div>
                          
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <p><strong>Upgrade Details:</strong></p>
                            <div className="ml-3">
                              {group.isLatestUpgrade ? (
                                // Latest upgrade: show from previousCourseName to parentCourseName
                                <div className="row">
                                  <div className="col-md-4">
                                    <p className="mb-1"><strong>From:</strong></p>
                                    <p>{group.previousCourseName}</p>
                                  </div>
                                  <div className="col-md-1 text-center">
                                    <span style={{ fontSize: '1.5rem', color: '#007bff', fontWeight: 'bold', margin: '0 15px' }}>→</span>
                                  </div>
                                  <div className="col-md-7">
                                    <p className="mb-1"><strong>To:</strong></p>
                                    <p><strong>{group.parentCourseName}</strong></p>
                                    <div className="mt-2">
                                      <p className="mb-1"><strong>Selected Courses:</strong></p>
                                      <ul className="list-unstyled mb-0" style={{ fontSize: '0.9rem' }}>
                                        {group.courseNames.map((courseName, courseIndex) => (
                                          <li key={courseIndex} className="mb-1">• {courseName}</li>
                                        ))}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                // Older upgrade: show from previousCourseName to the previousCourseName of latest upgrade
                                <div className="row">
                                  <div className="col-md-4">
                                    <p className="mb-1"><strong>From:</strong></p>
                                    <p>{group.previousCourseName}</p>
                                  </div>
                                  <div className="col-md-1 text-center">
                                    <span style={{ fontSize: '1.5rem', color: '#007bff', fontWeight: 'bold', margin: '0 15px' }}>→</span>
                                  </div>
                                  <div className="col-md-7">
                                    <p className="mb-1"><strong>To:</strong></p>
                                    <p><strong>{group.latestPreviousCourseName}</strong></p>
                                    <div className="mt-2">
                                      <p className="mb-1"><strong>Selected Courses:</strong></p>
                                      <ul className="list-unstyled mb-0" style={{ fontSize: '0.9rem' }}>
                                        {group.courseNames.map((courseName, courseIndex) => (
                                          <li key={courseIndex} className="mb-1">• {courseName}</li>
                                        ))}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {group.paymentReference && (
                          <div className="row mt-2">
                            <div className="col-md-12">
                              <p><strong>Payment Reference:</strong> {group.paymentReference}</p>
                            </div>
                          </div>
                        )}
                        {/* Action buttons for upgrade management */}
                        <div className="row mt-3">
                          <div className="col-md-12">
                            {!group.active && group.paymentReference && (
                              <button
                                className="btn btn-warning btn-sm mr-2"
                                onClick={() => handleRetryPayment(group)}
                                disabled={retryLoading}
                              >
                                {retryLoading ? "Retrying..." : "Retry Payment"}
                              </button>
                            )}
                            {group.active && !group.paymentReference && (
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => openCancelModal(group)}
                                disabled={cancelLoading}
                              >
                                Cancel Upgrade
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center text-muted">
                    <p>No upgrade history found.</p>
                  </div>
                )}
              </div>
            )}
          </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </Modal>

        {/* Cancel Upgrade Modal */}
        <Modal isOpen={cancelModal} toggle={() => setCancelModal(!cancelModal)} size="md">
          <ModalHeader toggle={() => setCancelModal(!cancelModal)}>Cancel Upgrade</ModalHeader>
          <ModalBody>
            {selectedRecord && (
              <div>
                <p><strong>Upgrade Details:</strong></p>
                <div className="mb-3 p-2 bg-light rounded">
                  <p className="mb-1"><strong>From:</strong> {selectedRecord.previousCourseName}</p>
                  <p className="mb-0"><strong>To:</strong> {selectedRecord.upgradedCourseName}</p>
                </div>
                
                <div className="form-group">
                  <label htmlFor="cancelReason" className="font-weight-bold">Reason for Cancellation *</label>
                  <textarea
                    id="cancelReason"
                    className="form-control"
                    rows="3"
                    value={cancelReason}
                    onChange={(e) => setCancelReason(e.target.value)}
                    placeholder="Please provide a reason for cancelling this upgrade..."
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="font-weight-bold">Upgrade Combination Preference</label>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      id="keepCombination"
                      className="form-check-input"
                      checked={keepCombination}
                      onChange={(e) => setKeepCombination(e.target.checked)}
                    />
                    <label htmlFor="keepCombination" className="form-check-label">
                      Keep this upgrade combination for future use
                    </label>
                    <small className="form-text text-muted">
                      If checked, this upgrade combination will be saved for future use. If unchecked, it will be deleted.
                    </small>
                  </div>
                </div>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button 
              color="danger" 
              onClick={confirmCancelUpgrade}
              disabled={cancelLoading || !cancelReason.trim()}
            >
              {cancelLoading ? "Cancelling..." : "Confirm Cancel"}
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  );
};

Courses.propTypes = {};

Courses.defaultProps = {};

export default Courses;
